function initCollectionPageFilterCheckboxes() {
  const collectionPageFilterOptions = document.querySelectorAll('.collection-page__sidebar-filter-checkbox');
  collectionPageFilterOptions.forEach((collectionPageFilterOption) => {
    collectionPageFilterOption.addEventListener('change', () => {
      const form = collectionPageFilterOption.closest('form');
      form.submit();
    });
  });
}


function initCollectionPageFilterMobileToggle() {
  const filterButton = document.querySelector('.collection-page__main-header-filter-button');
  const filterCloseButton = document.querySelector('.collection-page__main-header-filter-close-button');
  const sidebar = document.querySelector('.collection-page__sidebar');
  if (filterButton === null || filterCloseButton === null || sidebar === null) {
    return;
  }
  filterButton.addEventListener('click', () => {
    sidebar.classList.add('collection-page__sidebar--open');
    document.body.classList.add('body--no-scroll');
  });
  filterCloseButton.addEventListener('click', () => {
    sidebar.classList.remove('collection-page__sidebar--open');
    document.body.classList.remove('body--no-scroll');
  });
}


function initCollectionPageFilterToggles() {
  document.querySelectorAll('.collection-page__sidebar-filter').forEach((collectionPageFilter) => {
    const head = collectionPageFilter.querySelector('.collection-page__sidebar-filter-head');
    const body = collectionPageFilter.querySelector('.collection-page__sidebar-filter-body');
    const innerBody = body.querySelector('.collection-page__sidebar-filter-body-inner');
    if (collectionPageFilter.classList.contains('collection-page__sidebar-filter--open')) {
      body.style.height = innerBody.offsetHeight + 'px';
    }
    head.addEventListener('click', () => {
      if (collectionPageFilter.classList.contains('collection-page__sidebar-filter--open')) {
        body.style.height = '0';
        collectionPageFilter.classList.remove('collection-page__sidebar-filter--open');
      } else {
        body.style.height = innerBody.offsetHeight + 'px';
        collectionPageFilter.classList.add('collection-page__sidebar-filter--open');
      }
    });
  });
}


function initCollectionPageSort() {
  const collectionPageSorts = document.querySelectorAll('.collection-page__main-header-sort-dropdown');
  collectionPageSorts.forEach((collectionPageSort) => {
    collectionPageSort.addEventListener('change', (event) => {
      const urlSearchParams = new URLSearchParams(window.location.search);
      urlSearchParams.set('sort_by', event.currentTarget.value);
      urlSearchParams.delete('page');
      window.location.search = urlSearchParams.toString();
    });
  });
}


function initCollectionPage() {
  const collectionPage = document.querySelector('.collection-page');
  if (collectionPage === null) {
    return;
  }
  initCollectionPageFilterCheckboxes();
  initCollectionPageFilterMobileToggle();
  initCollectionPageFilterToggles();
  initCollectionPageSort();
}


if (document.readyState !== 'loading') {
  initCollectionPage();
} else {
  window.addEventListener('DOMContentLoaded', initCollectionPage);
}
